import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import NProgress from 'nprogress';


export const GetECMSClearanceTypeHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ecms/getClearanceType`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name || getDomain(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Clearance types retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve clearance types", hasError: true, data: err?.response?.data }
    });
};

export const AddECMSClearanceTypeHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/addClearanceType`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            clearance_type: params?.clearance_type,
            clearance_approver_fk: params?.clearance_approver_fk?.employee_id,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Clearance type added successfully");
        return { message: "Clearance type added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add clearance type", hasError: true, data: err?.response?.data }
    });
};

export const UpdateECMSClearanceTypeHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/ecms/updateClearanceType`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            clearance_type: params?.clearance_type,
            clearance_approver_fk: params?.clearance_approver_fk?.employee_id,
            clearance_type_configuration_pk: params?.clearance_type_configuration_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Clearance type updated successfully");
        return { message: "Clearance type updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update clearance type", hasError: true, data: err?.response?.data }
    });
};

export const DeleteECMSClearanceTypeHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/ecms/deleteClearanceType`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            clearance_type_configuration_pk: params?.clearance_type_configuration_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Clearance type deleted successfully");
        return { message: "Clearance type deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete clearance type", hasError: true, data: err?.response?.data }
    });
};
